import { createSelector } from "reselect";

import { getFilters } from "./state-accessors";

export const getSelectedAwardWinnersOnly = createSelector(
  [getFilters],
  filters => {
    return filters.award_winners_only;
  }
);
